import { MutationTree } from 'vuex'
import * as types from './mutation-types'

export const mutations: MutationTree<any> = {
  [types.DELETE_PROFILE] (state, payload) {
    state.current = null
  }
}
